function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon/Diagrams/Active/Area");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "hover",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon",
  transform: "translate(-438.000000, -84.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon/Diagrams/Active/Area",
  transform: "translate(438.000000, 84.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2-Copy-9",
  stroke: "#2D3C47",
  strokeWidth: 0.5,
  fillOpacity: 0.1,
  fill: "#FFFFFF",
  x: 0.25,
  y: 0.25,
  width: 17.5,
  height: 17.5,
  rx: 1
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(0.363342, 4.500000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.48458144,-4.79616347e-14 C6.92454572,-4.79616347e-14 8.15156784,1.51248507 9.16564781,4.53745521 C7.97952576,6.26484881 7.00857178,9.0946691 6.25309977,13.0267637 L6.254,13.02 L0.576845248,13.0200061 C0.300680342,13.0200469 0.0768044519,12.796171 0.0768044519,12.5200061 C0.0768044519,12.4957302 0.0785722694,12.4714865 0.0820938794,12.4474673 C1.29876513,4.14915577 3.09959431,-4.79616347e-14 5.48458144,-4.79616347e-14 Z",
  id: "Combined-Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.3520998,3.58333946 C14.7731103,3.58333946 16.4013953,6.68736313 17.2369548,12.8954105 C17.2448083,12.9503346 17.2062335,13.0009081 17.1512485,13.0083087 C17.1468068,13.0089066 17.1423302,13.0092065 17.1378485,13.0092065 L7.13976644,13.0092065 L7.13976644,13.0092065 C8.17889706,6.72529513 9.9163415,3.58333946 12.3520998,3.58333946 Z",
  id: "Path-6-Copy"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-2-Copy-9",
  stroke: "#2D3C47",
  strokeWidth: 0.5,
  x: 0.25,
  y: 0.25,
  width: 17.5,
  height: 17.5,
  rx: 1
}))));

var SvgArea = function SvgArea(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArea, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/area.cde8644b.svg";
export { ForwardRef as ReactComponent };